module.exports = __webpack_public_path__ + "static/ForTheKing0-25103a9c3e05c41d0a0926b2edcb62c0.png";